// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".xMFhR7TX8akeV_KDDfXk{position:relative;display:flex}.xMFhR7TX8akeV_KDDfXk .modal-header,.xMFhR7TX8akeV_KDDfXk .modal-content{padding-right:1.875rem;padding-left:1.875rem}.xMFhR7TX8akeV_KDDfXk .modal-header{position:relative}.oS36iX8mxDcLYGfk1nU7{display:none;width:auto;height:100%}.jLYdac7WhChWhq6Y49rQ{position:relative;background-color:#fff;width:100%}@media all and (min-width: 37.625em){.oS36iX8mxDcLYGfk1nU7{display:block}.xMFhR7TX8akeV_KDDfXk .modal-header{padding-top:5rem}.jLYdac7WhChWhq6Y49rQ{width:auto}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modalWithBackground": "xMFhR7TX8akeV_KDDfXk",
	"modalLeft": "oS36iX8mxDcLYGfk1nU7",
	"modalRight": "jLYdac7WhChWhq6Y49rQ"
};
export default ___CSS_LOADER_EXPORT___;
